function IsMinLaptop() {
  return window.matchMedia('(max-width: 1025px) and (min-width: 950px)')
    .matches;
}

export default IsMinLaptop;
